module.exports = __webpack_public_path__ + "media/INDEC.a2357007.mp4";